import React from 'react';

/*
 * compact offset pager: Prev / "start–end / total" / Next, the strings the lists already use.
 * aria-disabled with a guarded click, never native disabled, so Next on the last page keeps focus
 * (CD-101, CD-114, CD-151).
 */
export const page_bounds = ({ offset, rows, total, page_size }) => ({
  start: total === 0 ? 0 : offset + 1,
  end: Math.min(offset + rows, total),
  prev_off: offset <= 0,
  next_off: offset + page_size >= total
});

const Pager = ({ offset, rows, total, page_size, on_page }) => {
  if (total <= page_size) return null;
  const { start, end, prev_off, next_off } = page_bounds({ offset, rows, total, page_size });
  return (
    <div className="tp-pager">
      <button
        type="button"
        className="tp-btn-ghost"
        onClick={prev_off ? undefined : () => on_page(Math.max(0, offset - page_size))}
        aria-disabled={prev_off ? 'true' : undefined}
      >
        Prev
      </button>
      <span className="tp-card-hd-sub tp-pager-pos">
        {start}–{end} / {total}
      </span>
      <button
        type="button"
        className="tp-btn-ghost"
        onClick={next_off ? undefined : () => on_page(offset + page_size)}
        aria-disabled={next_off ? 'true' : undefined}
      >
        Next
      </button>
    </div>
  );
};

export default Pager;
